export default {
      id: "icon-youtube-usage",
      viewBox: "0 0 35.725 26.798",
      url: __webpack_public_path__ + "img/icons.svg#icon-youtube",
      toString: function () {
        return this.url;
      }
    }